import { Alert, AlertIcon, Center } from '@chakra-ui/react'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from 'react-use'
import { useRoute } from 'wouter'
import { apiConfig } from '../../common/apiConfig'
import { Container } from '../../common/components/Container'
import { TextLink } from '../../common/components/TextLink'
import { ApplicantProfileApi } from '../../generated'
import { Title } from '../components/Title'
import { signOut } from '../hooks/useApplicant'

type EmailChangeStatus = 'checking' | 'success' | 'error'

function getErrorMessage(status?: number) {
  switch (status) {
    case 403:
      return 'ログイン後、メール本文のURLを開き直してください。'
    case 404:
      return 'URLが無効です。'
    case 409:
      return 'メールアドレスが現在のアドレスと同じ、または他の申請者に使用されています。'
    default:
      return 'メールアドレス変更に失敗しました。'
  }
}

const EmailChangeComplete: FC = () => {
  const [t] = useTranslation()
  useTitle(t('AAO メールアドレス変更'))
  const [, params] = useRoute<{ id: string }>('/change-email-requests/:id')
  const token = params?.id
  const [status, setStatus] = useState<EmailChangeStatus>('checking')
  const [message, setMessage] = useState('メールアドレス変更を確認しています。')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage(getErrorMessage(404))
      return
    }
    new ApplicantProfileApi(apiConfig)
      .activateChangeEmail(token)
      .then(() => {
        setStatus('success')
        setMessage('メールアドレス変更が完了しました。')
        signOut()
      })
      .catch((error) => {
        setStatus('error')
        setMessage(getErrorMessage(error?.status))
      })
  }, [token])

  return (
    <Container innerWidth={'800px'}>
      <Title text={t('メールアドレス変更')} />
      <div className={'mt24'}>
        {status === 'error' ? (
          <Alert status={'error'}>
            <AlertIcon />
            {t(message)}
          </Alert>
        ) : (
          <>
            {t(message)}
            {status === 'success' && (
              <>
                <br />
                {t('トップページからログインしてください。')}
              </>
            )}
          </>
        )}
      </div>
      <div className={'mt24'}>
        <Center className={'mt8'}>
          <TextLink text={t('トップページへ戻る')} to={'/'} />
        </Center>
      </div>
    </Container>
  )
}

export default EmailChangeComplete
